import { Chart } from "chart.js";
import { LaneTempProfile } from "models/laneTempProfile/LaneTempProfile";
import moment from "moment";

export function formatTempItemsForChart(tempItems: LaneTempProfile[]) {
    const data = {
        maxTempData: tempItems.map((item) => ({
            x: moment(item.timeStamp).valueOf(),
            y: parseFloat(((item.maxTemp - 32) / 1.8).toFixed(2)),
        })),
        meanTempData: tempItems.map((item) => ({
            x: moment(item.timeStamp).valueOf(),
            y: parseFloat(((item.meanTemp - 32) / 1.8).toFixed(2)),
        })),
        minTempData: tempItems.map((item) => ({
            x: moment(item.timeStamp).valueOf(),
            y: parseFloat(((item.minTemp - 32) / 1.8).toFixed(2)),
        })),
    };

    return data;
}

export function calculateCrosshairLength(chart: Chart) {
    const oneHourInMilliseconds = 60 * 60 * 1000;

    let tickLength = oneHourInMilliseconds;

    if (chart.scales.x.ticks.length > 1) {
        tickLength =
            chart.scales.x.ticks[1].value - chart.scales.x.ticks[0].value;
    }

    const width =
        1 +
        (oneHourInMilliseconds * 25) /
            ((tickLength * chart.scales.x.ticks.length) / 10);

    return width;
}
